import { forwardRef } from 'react'

export const Image = forwardRef((props: any, ref) => {
    const inlineStyles = {
        opacity: props.faded ? '0.2' : '1',
        transformOrigin: '0 0',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundColor: 'grey',
        ...props.style,
    }

    return (
        <div ref={ref} style={inlineStyles} {...props} className={'virtualStoreContentImagesCard'}>
            <img src={props.url} alt={'not-found'} />
        </div>
    )
})
